
export class LRSDeclarationRequestModel {
    lrsDeclarationAmount: string;
    instituteName: string;
    transactionDate: string;
}
